import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/plus-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-3dd926ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "chr-incidents",
  class: "tw-flex tw-flex-col tw-items-start tw-gap-[40px] tw-self-stretch tw-bg-[#ffffff]"
}
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-gap-[16px] !tw-break-inside-avoid" }
const _hoisted_3 = { class: "tw-flex tw-justify-between tw-w-[100%]" }
const _hoisted_4 = { class: "tw-flex tw-items-center" }
const _hoisted_5 = {
  id: "chr-sheading-incidents",
  class: "tw-text-[#211F58] tw-text-[24px] tw-font-semibold tw-w-fit"
}
const _hoisted_6 = { class: "tw-flex tw-items-center tw-gap-5" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tw-w-[12px] tw-h-6",
  src: _imports_0,
  alt: "sub"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "tw-text-[#231F20] tw-text-[14px] tw-font-normal xl:tw-w-[50%] tw-opacity-[0.7]" }

import { getComponentUiText } from "@/utils/utilities";
import { computed, Ref, ref, watch } from "vue";
import IncidentsAndEventsTable from "./incidentsAndEventsTable.vue";
import Pen from "@/components/svgs/pen.vue";
import store from "@/store";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";


export default /*#__PURE__*/_defineComponent({
  __name: 'incidentsAndEvents',
  props: {
  isLoading: {
    type: Boolean,
    default: true,
  },
  isEdit: {
    type: Boolean,
    default: false,
  },
  isDiscard: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:edit"],
  setup(__props, { emit }) {

const props = __props;




const isCallApi: Ref<boolean> = ref(false);

const customTableData: Ref<any> = computed(() => {
  return store.getters["Sharing/getChecklistIncidents"];
});

const editNotes = () => {
  emit("update:edit", !props.isEdit);
  if (!isCallApi.value) {
    isCallApi.value = false;
  }
};

// add new data
const addNew = () => {
  eventEmitter.emit(EmitterEvents.SHARING_ADD_INCIDENT);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)(
                "app-share-cyber-profile-incidents-and-events-title-1",
              )), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (__props.isEdit)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "tw-rounded-full tw-bg-[#387DFF] tw-w-[28px] tw-h-[28px] tw-flex tw-justify-center tw-items-center tw-cursor-pointer",
                onClick: addNew
              }, _hoisted_8))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            id: "pen-icon-incidents",
            class: _normalizeClass([[
              __props.isEdit ? 'is_editable' : 'not_editable',
              isCallApi.value
                ? '!tw-cursor-not-allowed !tw-bg-[#211F58] !tw-p-[5px]'
                : '',
            ], "header__pen tw-flex tw-items-center tw-justify-center tw-cursor-pointer"]),
            onClick: editNotes
          }, [
            _createVNode(Pen, {
              "is-call-api": isCallApi.value,
              color: __props.isEdit ? '#ffffff' : '#387DFF'
            }, null, 8, ["is-call-api", "color"])
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(getComponentUiText)(
            "app-rshare-cyber-profile-incidents-and-events-sub-title-1",
          )), 1)
    ]),
    _createVNode(IncidentsAndEventsTable, {
      "is-loading": __props.isLoading,
      "is-show-edit": __props.isEdit,
      data: customTableData.value,
      "is-edit": __props.isEdit,
      "is-discard": __props.isDiscard,
      onCallApi: _cache[0] || (_cache[0] = ($event: any) => (isCallApi.value = $event))
    }, null, 8, ["is-loading", "is-show-edit", "data", "is-edit", "is-discard"])
  ]))
}
}

})